export const KEY_POST_ACCEPT_INVITATION = 'post.accept-invitation.call';
export const KEY_GET_CONFIRM_TOKEN = 'get.confirm-token.call';
